// Preserve Shopify's translated block and its authoring origin; enhance placement only.
(() => {
  if (window.pogiHomePromise) { window.pogiHomePromise(); return; }
  const records = new Map();
  const finish = (record) => record.node.classList.remove('is-foil-visible');
  const forget = (record) => {
    record.observer?.disconnect();
    record.node.removeEventListener('animationend', record.onEnd);
    record.node.removeEventListener('animationcancel', record.onEnd);
    records.delete(record.key);
  };
  const restore = (record) => {
    if (record.origin.isConnected) record.origin.after(record.node);
    else record.node.remove();
    record.node.removeAttribute('data-pogi-promise-relocated');
  };
  const watch = (record) => {
    if (record.node.dataset.foilSeen || record.observer ||
        !('IntersectionObserver' in window) ||
        window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    record.observer = new IntersectionObserver(entries => {
      if (!entries.some(entry => entry.isIntersecting)) return;
      record.node.dataset.foilSeen = 'true';
      record.node.classList.add('is-foil-visible');
      record.observer.disconnect();
      record.observer = null;
    }, { threshold: 0.5 });
    record.observer.observe(record.node);
  };
  const refresh = () => {
    const origins = [...document.querySelectorAll('[data-pogi-promise-origin]')];
    for (const record of records.values()) {
      if (!record.origin.isConnected) { record.node.remove(); forget(record); }
    }
    const slots = [...document.querySelectorAll('[data-pogi-promise-slot]')];
    // Missing or ambiguous source/destination: retain each server-rendered source.
    if (slots.length !== 1 || origins.length !== 1) {
      for (const record of records.values()) restore(record);
      return;
    }
    const slot = slots[0];
    for (const origin of origins) {
      const key = origin.dataset.pogiPromiseOrigin;
      let record = records.get(key);
      if (origins.filter(item => item.dataset.pogiPromiseOrigin === key).length !== 1) {
        if (record) restore(record);
        continue;
      }
      if (record && record.origin !== origin) { record.node.remove(); forget(record); record = null; }
      if (!record) {
        const node = origin.nextElementSibling;
        if (!node || node.dataset.pogiPromise !== key) continue;
        record = { key, origin, node, observer: null };
        record.onEnd = event => { if (event.animationName === 'pogi-foil-glint') finish(record); };
        node.addEventListener('animationend', record.onEnd);
        node.addEventListener('animationcancel', record.onEnd);
        records.set(key, record);
      }
      if (record.node.parentElement !== slot) slot.append(record.node);
      record.node.setAttribute('data-pogi-promise-relocated', '');
      watch(record);
    }
  };
  window.pogiHomePromise = refresh;
  document.addEventListener('shopify:section:unload', event => {
    for (const record of records.values()) {
      if (event.target.contains(record.origin)) {
        record.node.remove(); forget(record);
      } else if (event.target.contains(record.node)) {
        restore(record);
      }
    }
  });
  document.addEventListener('shopify:section:load', refresh);
  document.addEventListener('shopify:section:reorder', refresh);
  document.addEventListener('shopify:block:select', event => {
    const node = event.target.closest('[data-pogi-promise]');
    if (node) node.scrollIntoView({ block: 'nearest', behavior: 'instant' });
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refresh, { once: true });
  else refresh();
})();
